import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Navbar from "../navbar/Navbar";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import Button from "@material-ui/core/Button";
import Footer from "../footer/footer";
import { Link } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  }
}));

export default function ControlledExpansionPanels() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Navbar />
      <Link to="/Notes" id="back">
        <Button
          style={{ margin: "10px", marginTop: "70px" }}
          variant="contained"
          color="primary"
          href="#contained-buttons"
        >
          <KeyboardBackspaceIcon />
        </Button>
      </Link>
      <h1 id="desc" style={{ textAlign: "center" }}>
        Eighth sem CSE/ISE Notes
      </h1>

      <ExpansionPanel
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        style={{ marginTop: "40px" }}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className={classes.heading}>
            Internet Of Things{" "}
          </Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a href="https://drive.google.com/file/d/1R_WpTvXsEHlBw4QKZc0VlBx2qNhNU_5p/view?usp=sharing">
                module 1
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1NzFSIQqU6jLiMJCmrzp1K1z7_dTZWVJg/view?usp=sharing">
                module 2
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1NzFSIQqU6jLiMJCmrzp1K1z7_dTZWVJg/view?usp=sharing">
                module 3
              </a>

              <br />
              <a href="https://drive.google.com/file/d/1LI2Rgf_nMjuEP3LdkUDyTMtLE53diKs9/view?usp=sharing">
                module 4
              </a>
              <br />
              <a href="https://drive.google.com/file/d/184a0-hMUa2EwCCPvtjX_EAekgFoyAozx/view?usp=sharing">
                module 5
              </a>
              <br />
            </div>
          </Typography>
          <Typography style={{ marginLeft: '30px' }}>
            <div style={{ color: "black" }}>
              <iframe style={{ width: '120px', height: '240px' }} marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=9386858959&asins=9386858959&linkId=31013b140dc26c98167f38839c1fe1fb&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className={classes.heading}>Big Data</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a href="https://drive.google.com/file/d/13XrzUOptR2ZCxtWy5CH-G944GyzDThtX/view?usp=sharing">
                module 1
              </a>
              <br />

              <a href="https://drive.google.com/file/d/1hhgxHEgQmNeBxitwKZBSgfT8E890KqvB/view?usp=sharing">
                module 3
              </a>
              <br />
              <div style={{ color: "black", marginTop: '15px' }}>

                <a href="https://drive.google.com/file/d/1bnTX_NZ1BiJrEEObtn9Aks-T3tV2Xugq/view?usp=sharing">
                  module 1(ppt)
          </a>
                <br />

                <a href="https://drive.google.com/file/d/1aeUbr-lw0fc5sgBMnwtq4-zMtH7q_riR/view?usp=sharing">
                  module 2(ppt)
          </a>
                <br />

                <a href="https://drive.google.com/file/d/1RvJRt2jsNfIFmxMEKICMNJqEFMWvjcAS/view?usp=sharing">
                  module 3(ppt)
          </a>
                <br />
                <a href="https://drive.google.com/file/d/18mbYL6v4d6WNMaaOTbXueowoTaaQLBZX/view?usp=sharing">
                  module 4(ppt)
          </a>
                <br />
                <a href="https://drive.google.com/file/d/1Yorkv4zOX8Yr2qO8ws40ZQj2kTuk-YqM/view?usp=sharing">
                  module 5(ppt)
          </a>
                <br />
              </div>

            </div>
          </Typography>
          <Typography style={{ marginLeft: '20px' }}>
            <div style={{ color: "black" }}>
              <iframe style={{ width: '120px', height: '240px' }} marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=0134049942&asins=0134049942&linkId=a3564dd78760704569831101dc384edf&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>
              <br />
            </div>
          </Typography>
          <Typography style={{ marginLeft: '30px' }}>
            <div style={{ color: "black" }}>

              <iframe style={{ width: '120px', height: '240px' }} marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=B00K2I2JL8&asins=B00K2I2JL8&linkId=435ac7d3600951cd620cbcba32512217&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className={classes.heading}>Network Management</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a href="https://drive.google.com/file/d/1sMXVnmbJcJ6Jdv9gZeCuqQ0I8Gbd4pTv/view?usp=sharing">
                module 1
              </a>
              <br />
              <a href="https://drive.google.com/file/d/17PJc_y9Z1DT0_WH9Yobe5FCyzTob1HaA/view?usp=sharing">
                module 2
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1UKT6GAgh3Xdncf_vPxFeGlyMa0FLuZJR/view?usp=sharing">
                module 3
              </a>
              <br />

              <a href="https://drive.google.com/file/d/1n7MZfpNVfj4uM2Xv7vH5EFQJPWtrQUjI/view?usp=sharing">
                module 4
              </a>
              <br />

              <a href="https://drive.google.com/file/d/1ai4mXS8b2YaOK2Gkxj-8s8FrrNSXd2d8/view?usp=sharing">
                module 5
              </a>
              <br />

            
            </div>
          </Typography>
          <Typography style={{ marginLeft: '30px' }}>
            <div style={{ color: "black" }}>
              <iframe style={{ width: '120px', height: '240px' }} marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=8131727599&asins=8131727599&linkId=7f8eb823ddec0b5e6e3d051535fd7f53&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>
              <br />
            </div>
          </Typography>
          <Typography style={{ marginLeft: '30px' }}>
            <div style={{ color: "black" }}>
              <iframe style={{ width: '120px', height: '240px' }} marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=9333213635&asins=9333213635&linkId=984247c2e32fd503622316e86116ecc0&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>


      <Footer />
    </div>
  );
}
